import React from 'react';
import { makeStyles } from '../../theme';
import cx from 'classnames';
import useConfig from '../../../config';
import { getImageResourcePath, isExternalPath } from '../../../util/client';
import { concatUrl } from '../../../util';

const styles = makeStyles({
	img: {
		objectFit: 'contain'
	}
});

const Img = React.memo(({className, src, ...props}) => {
	const classes = styles();
	const config = useConfig();
	const rpath = getImageResourcePath(src);
	if(!isExternalPath(rpath)) src = concatUrl(rpath, config.baseUrl);
	return <img alt="" {...props} src={src} className={cx(classes.img, className)}/>
});

export default Img;